import { makeAutoObservable, onBecomeObserved } from "mobx"

import { notify } from "@src/app/components/notify"
import { APIPagination, projectsApi } from "@src/shared/api"

export class ProjectStore {
  id: string
  isLoading = true

  loadProject = async () => {
    try {
      this.isLoading = true

      const { data: result } = await projectsApi.getProject(this.id)

      if (result.success) {
        // @ts-ignore
        this.project = result.data
      } else {
        notify.error()
      }
    } catch (error) {
      notify.error()
    } finally {
      this.isLoading = false
    }
  }
  pageSize = 25
  project?: any
  total?: APIPagination["total"]

  constructor(id: string) {
    this.id = id

    makeAutoObservable(this)

    onBecomeObserved(this, "project", this.loadProject)
  }
}
